import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ClassService } from '../../../../../services/class';
import { TeacherService } from '../../../../../services/teacher';
import { Session } from '../../../../../services/session';
import { ApiEndpoints } from '../../../../../core/api-endpoints';
import { IClass } from '../../../../../interfaces/class';
import { ITeacher } from '../../../../../interfaces/teacher';
import { FlashService } from '../../../../../services/flash';

@Component({
  selector: 'app-class-attendance',
  imports: [RouterLink, ReactiveFormsModule, RouterOutlet],
  templateUrl: './class-attendance.html',
  styleUrl: './class-attendance.css',
})
export class ClassAttendance {
  constructor(
    private classService: ClassService,
    private teacherService: TeacherService,
    private session: Session,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.classId = params.get('id')!;
    });

    if (!this.classId) {
      void this.router.navigate(['/dashboard/class']);
    }

    this.loggedUserId = this.session.getDecodedUser()?.sub;
    this.loggedUserRole = this.session.getDecodedUser()?.role;

    this.getClass();
  }

  protected classId!: string;
  protected class = signal<IClass | null>(null);
  protected readonly flashService = inject(FlashService);
  protected loggedUserId: string | undefined;
  protected loggedUserRole: string | undefined;
  protected isClassTeacher = signal<boolean>(false);

  protected getClass(): void {
    this.classService.getClassById(`${ApiEndpoints.url}/class/${this.classId}`).subscribe({
      next: (res) => {
        this.class.set(res);
        this.checkClassTeacher(res?.payload?.class_teacher_id);
      },
      error: (err) => {
        this.flashService.failure(err?.error?.message ?? 'Could not load classes. Refresh the page');
      },
    });
  }

  protected checkClassTeacher(classTeacherId: string | undefined): void {
    if (!this.loggedUserId || !classTeacherId) {
      this.isClassTeacher.set(false);
      return;
    }

    this.teacherService.getTeacherById(`${ApiEndpoints.url}/teacher/${classTeacherId}`).subscribe({
      next: (teacher: ITeacher) => {
        this.isClassTeacher.set(teacher?.payload?.user_id === this.loggedUserId);
      },
      error: () => {
        this.isClassTeacher.set(false);
      },
    });
  }

  protected navigateToAttendanceRecord(): void {
    void this.router.navigate(['/dashboard/class/class-attendance/attendance-register'], {
      queryParams: {
        id: this.classId,
      },
    });
  }

  protected navigateToAttendanceHistory(): void {
    void this.router.navigate(['/dashboard/class/class-attendance/attendance-history'], {
      queryParams: {
        id: this.classId,
      },
    });
  }
}
